import { Expose } from 'class-transformer';

/**
 * ID 首页放款摘要模型(数据来源：query_disburse_summary，由 fastescrow 提供)
 */
export class DisburseSummaryModel {
  /** 今日 Loan#1(Cache Advance)预计放款金额 */
  @Expose()
  loan1_disburse_amount: string = '0';

  /** 今日 Loan#2(发货放款)预计放款金额 */
  @Expose()
  loan2_disburse_amount: string = '0';

  /** 下一次放款将要收到的金额，扣除了服务费 */
  @Expose()
  to_be_received_amount: string = '0';

  /** 今日 Loan#1(Cache Advance)预计放款时间 */
  @Expose()
  loan1_disburse_time: number = 0;

  /** 今日 Loan#2(发货放款)预计放款时间 */
  @Expose()
  loan2_disburse_time: number = 0;
}
